module.exports = __webpack_public_path__ + "img/22.e40f49e1.png";